// extracted by mini-css-extract-plugin
export default {"stack":"toaster_stack__SYpsq","alert":"toaster_alert__apfD3"};